export const RBH_MESSAGE_TH = {
  //login
  "main.login.title": "เข้าสู่ระบบ Robinhood Shop",
  "main.login.email.title": "อีเมล",
  "main.login.email.placeholder": "ใส่อีเมล",
  "main.login.email.format.valid": "รูปแบบอีเมลไม่ถูกต้อง",
  "main.login.password.title": "รหัสผ่าน",
  "main.login.password.placeholder": "ใส่รหัสผ่าน",
  "main.login.rememberme": "บันทึกอีเมลและรหัสผ่านนี้",
  "main.login.forgotpassword": "ลืมรหัสผ่าน",
  "main.login.submit": "เข้าสู่ระบบ",
  "main.login.error.model.title": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  "main.login.error.model.content": "กรุณาลองใหม่อีกครั้ง",
  "main.preload.error.modal.content": "ร้านของคุณถูกระงับการให้บริการ\nหรือคุณไม่มีสิทธิ์ในการจัดการสาขา\nกรุณาติดต่อ LINE OA: @robinhoodshop",
  "main.forgotpassword.verifyemail.modal.title": "อีเมลไม่ถูกต้อง",
  "main.forgotpassword.verifyemail.modal.description": "กรุณาลองใหม่อีกครั้ง",
  "main.forgotpassword.sendemail.modal.title": "ไม่สามารถดำเนินการต่อได้",
  "main.forgotpassword.sendemail.modal.description": "คุณขอรหัสยืนยันเกินจำนวนครั้งที่กำหนด กรุณารอ 60 นาทีเพื่อขอรหัสยืนยันใหม่",
  "main.forgotpassword.title": "ลืมรหัสผ่าน",
  "main.forgotpassword.description": "กรุณาใส่อีเมลที่คุณใช้ลงทะเบียนขอใช้บริการ เพื่อรับรหัสยืนยันทางอีเมล",
  "main.forgotpassword.form.title": "อีเมล",
  "main.forgotpassword.form.placeholder": "ใส่อีเมล",
  "main.forgotpassword.form.button": "ส่งรหัสยืนยัน",
  "main.forgotpassword.linkable": "กลับหน้าเข้าสู่ระบบ",
  "main.forgotpassword.successbox.title": "ส่งรหัสผ่านไปยังอีเมลของคุณแล้ว",
  "main.forgotpassword.successbox.description": "กรุณาใช้รหัสผ่านนี้ในการลงชื่อเข้าสู่ระบบ",
  "main.setnewpassword.title": "ตั้งรหัสผ่านใหม่",
  "main.setnewpassword.description": "ใส่รหัสยืนยันที่ส่งไปยังอีเมลของคุณ และตั้งรหัสผ่านใหม่",
  "main.setnewpassword.form.verifycode.title": "รหัสยืนยัน",
  "main.setnewpassword.form.verifycode.placeholder": "ใส่รหัสยืนยัน",
  "main.setnewpassword.form.newpassword.title": "รหัสผ่านใหม่",
  "main.setnewpassword.form.newpassword.placeholder": "ใส่รหัสผ่านใหม่",
  "main.setnewpassword.form.confirmpassword.title": "ยืนยันรหัสผ่านใหม่",
  "main.setnewpassword.form.confirmpassword.placeholder": "ใส่รหัสผ่านใหม่อีกครั้ง",
  "main.setnewpassword.form.confirmpassword.button": "ตั้งรหัสผ่าน",
  "main.setnewpassword.form.error.formatpassword": "กรุณาตั้งรหัสผ่านที่ประกอบด้วยความยาว 8 ตัวอักษร เพื่อความปลอดภัย",
  "main.setnewpassword.form.error.samepassword": "รหัสผ่านไม่ตรงกัน กรุณาใส่รหัสผ่านใหม่อีกครั้ง",
  "main.setnewpassword.successbox.title": "ตั้งรหัสผ่านใหม่สำเร็จ",
  "main.setnewpassword.successbox.description": "คุณสามารถใช้รหัสผ่านใหม่ในการลงชื่อเข้าสู่ระบบได้ทันที",
  "main.setnewpassword.successbox.button": "เข้าสู่ระบบ",
  "main.setnewpassword.error.limitExceededException.title": "ไม่สามารถดำเนินการต่อได้",
  "main.setnewpassword.error.limitExceededException.description": "คุณใส่รหัสยืนยันไม่ถูกต้องเกินจำนวนครั้งที่กำหนด กรุณารอ 60 นาทีเพื่อขอรหัสยืนยันใหม่",
  "main.setnewpassword.error.codeMismatchException.title": "ไม่สามารถดำเนินการต่อได้",
  "main.setnewpassword.error.codeMismatchException.description": "รหัสยืนยันไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  "main.setnewpassword.error.expiredCodeException.title": "ไม่สามารถดำเนินการต่อได้",
  "main.setnewpassword.error.expiredCodeException.description": "รหัสยืนยันหมดอายุ กรุณาขอรหัสยืนยันใหม่ และลองอีกครั้ง",
  "main.addbranch": "เพิ่มข้อมูลสาขา",
  "main.addbranch.remark": "หากมีการแก้ไขข้อมูล ระบบจะอนุมัติร้านค้าภายใน 3 วันทำการ หากไม่ได้รับผลการอนุมัติ กรุณาติดต่อ LINE OA: @robinhoodshop",
  "main.adddistrict": "เขต",
  "main.addprovince": "จังหวัด",
  "main.addsubdistrict": "ใส่แขวง",
  "main.addzipcode": "ใส่รหัสไปรษณีย์",
  "main.back": "กลับ",
  "main.branchempty.content": "เพื่อข้อมูลเพื่อจัดการร้านค้าของคุณ",
  "main.branchempty.header": "ไม่มีข้อมูลสาขา",
  "main.branchform.add": "เพิ่ม",
  "main.branchform.addaddress": "ใส่ที่อยู่สาขา (ไม่เกิน 200 ตัวอักษร)",
  "main.branchform.addbranchid": "ใส่รหัสอ้างอิงสาขา (ไม่เกิน 100 ตัวอักษร)",
  "main.branchform.addbranchname": "ใส่ชื่อร้านและสาขา (ไม่เกิน 100 ตัวอักษร)",
  "main.branchform.adddescription": "ใส่คำอธิบายสาขา (ไม่เกิน 200 ตัวอักษร)",
  "main.branchform.addlandmark": "ใส่จุดสังเกตที่ตั้งสาขา (ไม่เกิน 200 ตัวอักษร)",
  "main.branchform.addlat": "เลือกละติจูด",
  "main.branchform.addlng": "เลือกลองจิจูด",
  "main.branchform.addphone": "ใส่เบอร์โทรศัพท์ (ไม่เกิน 10 ตัวอักษร)",
  "main.branchform.address": "ที่อยู่สาขา",
  "main.branchform.addshopphoto": "ใส่รูปถ่ายร้านค้า",
  "main.branchform.branchclosed": "ปิดทำการ",
  "main.branchform.branchid": "รหัสอ้างอิงสาขา",
  "main.branchform.branchname": "ชื่อร้านและสาขา",
  "main.branchform.branchopen": "เปิดทำการ",
  "main.branchform.branchstatus": "สถานะร้าน",
  "main.branchform.cancel": "ยกเลิก",
  "main.branchform.choosemap": "ยืนยัน",
  "main.branchform.choosephoto": "เลือกรูป",
  "main.branchform.close": "ปิด",
  "main.branchform.description": "คำอธิบายสาขา",
  "main.branchform.friday": "วันศุกร์",
  "main.branchform.landmark": "จุดสังเกตที่ตั้งสาขา",
  "main.branchform.lat": "ละติจูด",
  "main.branchform.lng": "ลองจิจูด",
  "main.branchform.monday": "วันจันทร์",
  "main.branchform.open": "เปิด",
  "main.branchform.opendate": "เวลาเปิด-ปิดรับคำสั่งซื้อ",
  "main.branchform.phone": "เบอร์โทรศัพท์",
  "main.branchform.saturday": "วันเสาร์",
  "main.branchform.save": "บันทึก",
  "main.branchform.shopphoto": "รูปโลโก้หรือรายการแนะนำของร้านค้า",
  "main.branchform.sunday": "วันอาทิตย์",
  "main.branchform.thursday": "วันพฤหัสบดี",
  "main.branchform.tuesday": "วันอังคาร",
  "main.branchform.warningphoto": "ไฟล์ .jpg หรือ .png ขนาดไม่เกิน 3MB",
  "main.branchform.wednesday": "วันพุธ",
  "main.branchform.openhour.time.open": "เวลาเปิด",
  "main.branchform.openhour.time.close": "เวลาปิด",
  "main.branchform.openhour.time.applyallday": "เปิด 24 ชั่วโมง",
  "main.branchmanagement": "จัดการสาขา",
  "main.branchmapping.subtitle": "สำหรับร้านค้าใหม่ หรือร้านค้าที่ไม่ผ่านอนุมัติ สถานะร้านจะเปลี่ยนตามที่คุณกำหนด เมื่อร้านค้าของคุณได้รับการอนุมัติแล้ว",
  "main.branchmapping.refcode": "รหัสอ้างอิงสาขา",
  "main.branchmapping.tel": "โทร.",
  "main.branchmapping.addvataddress": "เพิ่มที่อยู่ใบกำกับภาษี",
  "main.branchmapping.backstep2": "สาขา",
  "main.branchmapping.centerstep2": "สาขา จากทั้งหมด",
  "main.branchmapping.choosevatplacegolder": "เลือกที่อยู่ใบกำกับภาษี",
  "main.branchmapping.frontstep2": "ขั้นตอนที่ 2: สาขาที่ใช้ที่อยู่นี้ จำนวน",
  "main.branchmapping.step1": "ขั้นตอนที่ 1: ที่อยู่ใบกำกับภาษี",
  "main.branchmapping.title": "กำหนดที่อยู่ใบกำกับภาษีของสาขา",
  "main.branchmapping.title2": "ที่อยู่ใบกำกับภาษี",
  "main.branchmapping": "กำหนดที่อยู่ใบกำกับภาษีของสาขา",
  "main.branchmapping.column1": "สาขา",
  "main.branchmapping.column2": "ที่อยู่ใบกำกับภาษี",
  "main.branchmapping.alert.success": "กำหนดที่อยู่ใบกำกับภาษีของสาขาสำเร็จแล้ว",
  "main.branchmapping.alert.fail": "กำหนดที่อยู่ใบกำกับภาษีของสาขาไม่สำเร็จ",
  "main.branchtable.addbranchname": "ใส่ชื่อร้านและสาขา",
  "main.branchtable.branchaddress": "ที่อยู่สาขา",
  "main.branchtable.branchdelete": "ลบ",
  "main.branchtable.branchedit": "แก้ไข",
  "main.branchtable.branchname": "ชื่อร้านค้าและสาขา",
  "main.branchtable.shopId": "รหัสร้านค้า",
  "main.branchtable.branchopen": "เวลาเปิด-ปิดรับคำสั่งซื้อ",
  "main.branchtable.branchphone": "เบอร์โทรศัพท์",
  "main.branchtable.branchstatus": "สถานะร้าน",
  "main.branchtable.statusactive": "เปิดทำการ",
  "main.branchtable.statusinactive": "ปิดทำการ",
  "main.branchtable.willOpen": "\nเปิดวันที่ {date}",
  "main.branchtable.closedIndefinitely": "\nไม่ระบุวันเปิด",
  "main.branchtable.statusshop.onlytoday": "ปิดวันนี้",
  "main.branchtable.statusshop.onlytodaydesc": "เปิดรับคำสั่งซื้ออัตโนมัติในวันทำการถัดไป",
  "main.branchtable.statusshop.tempclose": "ปิดชั่วคราว",
  "main.branchtable.statusshop.tempclosedesc": "ปิดได้ไม่เกิน {date} วัน",
  "main.branchtable.statusshop.tempclose.error": "กรุณาเลือกวันที่ต้องการเปิดรับคำสั่งซื้อ",
  "main.branchtable.statusshop.tempclosecalendarplaceholder": "เลือกวันที่จะเปิดรับคำสั่งซื้อ",
  "main.branchtable.statusshop.notspecify": "ไม่ระบุวันเปิด",
  "main.branchtable.statusshop.notspecifydesc": "จนกว่าจะเลื่อนเปลี่ยนสถานะเป็น \"เปิดรับคำสั่งซื้อ\"",
  "main.branchtable.statusshop.remark": "หมายเหตุ",
  "main.branchtable.statusshop.remarkdesc1": "เนื่องจากระบบจะปิดปรับปรุงข้อมูลระหว่างเวลา 23:00-01:00 น. ของทุกวัน",
  "main.branchtable.statusshop.remarkdesc2": "จึงไม่สามารถเลือก \"ปิดวันนี้\" หรือ \"ปิดชั่วคราว\" ในช่วงเวลาดังกล่าวได้",
  "main.branchtable.statusshop.qc.remark": "สำหรับร้านค้าใหม่ หรือร้านค้าที่ไม่ผ่านอนุมัติ สถานะร้านจะเปลี่ยนตามที่คุณกำหนด\nเมื่อร้านค้าของคุณได้รับการอนุมัติแล้ว",
  "main.branchtable.statusshop.invalidtime": "ไม่สามารถเลือก \"ปิดวันนี้\" หรือ \"ปิดชั่วคราว\" ระหว่างเวลา 23:00 - 01:00 น. เนื่องจากระบบปิดเพื่อปรับปรุงข้อมูล หากต้องการปิดร้านทันที กรุณาเลือก “ไม่ระบุวันเปิด”",
  "main.button_cancel": "ยกเลิก",
  "main.button_confirm": "ยืนยัน",
  "main.button_save": "บันทึก",
  "main.button_ok": "ตกลง",
  "main.callapi": "เทสคอล API",
  "main.choosebranch": "เลือกสาขา",
  "main.confirm_edit_content": "ข้อมูลที่คุณใส่หรือแก้ไขไว้ยังไม่ถูกบันทึกลงในระบบ\nหากคุณออกจากหน้านี้ ข้อมูลนั้นจะหายไป\nคุณต้องการออกจากหน้านี้หรือไม่",
  "main.confirm_edit_header": "ยืนยันการออกจากหน้านี้",
  "main.confirm_mapping_content": "สำหรับสาขาที่คุณยกเลิกการเลือกที่อยู่ใบกำกับภาษี กรุณาเลือกที่อยู่ใบกำกับภาษีใหม่ของสาขานั้นเพื่ออัปเดตข้อมูลในระบบ",
  "main.confirm_mapping_header": "การเปลี่ยนที่อยู่ใบกำกับภาษี",
  "main.delete": "ลบ",
  "main.edit": "แก้ไข",
  "main.editbranch": "แก้ไขข้อมูลสาขา",
  "main.editbranch.remark": "หากมีการแก้ไขข้อมูล ระบบจะอนุมัติร้านค้าภายใน 3 วันทำการ หากไม่ได้รับผลการอนุมัติ กรุณาติดต่อ LINE OA: @robinhoodshop",
  "main.editbranch.qc.reject.title": "ร้านค้าของคุณไม่ผ่านอนุมัติ",
  "main.editbranch.qc.reject.reason.title": "ร้านค้าของคุณไม่ผ่านอนุมัติ เนื่องจาก",
  "main.editbranch.qc.reject.desc": "กรุณาแก้ไขข้อมูล แล้วรอตรวจสอบภายใน 3 วันทำการ หรือติดต่อ LINE OA: @robinhoodshop",
  "main.foodcategory": "หมวดหมู่",
  "main.qctag.approve": "อนุมัติแล้ว",
  "main.qctag.pending": "รออนุมัติ",
  "main.qctag.reject": "ไม่ผ่านอนุมัติ",
  // food menu
  "main.foodmenu": "รายการขาย",
  "main.foodmenu.landing.breadcrumb": "รายการขาย",
  "main.edit_foodmenu": "แก้ไขรายการขาย",
  "main.foodmenu.subtitle": "สำหรับรายการใหม่ หรือรายการที่ไม่ผ่านอนุมัติ สถานะรายการบนแอปจะเปลี่ยนเป็นขายได้ เมื่อรายการได้รับการอนุมัติแล้ว",
  "main.foodmenu.landing.header": "รายการขาย",
  "main.foodmenu.landing.table.name": "ชื่อรายการ",
  "main.foodmenu.landing.table.price": "ราคา (บาท)",
  "main.foodmenu.landing.table.category": "หมวดหมู่",
  "main.foodmenu.landing.table.status": "สถานะรายการ",
  "main.foodmenu.landing.table.edit": "แก้ไข",
  "main.foodmenu.landing.table.delete": "ลบ",
  "main.foodmenu.empty.header": "ไม่มีรายการขาย",
  "main.foodmenu.empty.content": "เพิ่มหมวดหมู่และรายการเพื่อเริ่มการขาย",
  "main.foodmenu.addEdit.qc.desc": "หากมีการเพิ่มหรือแก้ไขรูป ชื่อ ราคา ระบบจะอนุมัติภายใน 3 วันทำการ หากไม่ได้รับผลการอนุมัติ กรุณาติดต่อ LINE OA: @robinhoodshop",
  "main.foodmenu.addEdit.qc.reject.reasons.header1": "รายการของคุณไม่ผ่านอนุมัติ เนื่องจาก",
  "main.foodmenu.addEdit.qc.reject.header1": "รายการของคุณไม่ผ่านอนุมัติ",
  "main.foodmenu.addEdit.qc.reject.header2": "กรุณาแก้ไขข้อมูล แล้วรอตรวจสอบภายใน 3 วันทำการ หรือติดต่อ LINE OA: @robinhoodshop",
  // food add menu
  "main.foodmenu.addmenu.breadcrumb": "เพิ่มรายการขาย",
  "main.foodmenu.addmenu.header": "เพิ่มรายการขาย",
  "main.foodmenu.addmenu.category.title": "หมวดหมู่",
  "main.foodmenu.addmenu.tags.title": "ประเภท",
  "main.foodmenu.addmenu.category.placeholder": "เลือกหมวดหมู่",
  "main.foodmenu.addmenu.tags.placeholder": "เลือกประเภท",
  "main.foodmenu.addmenu.category.addcategort": "เพิ่มหมวดหมู่",
  "main.foodmenu.addmenu.menu.title": "ชื่อรายการ",
  "main.foodmenu.addmenu.menu.placeholder": "ใส่ชื่อรายการ (ไม่เกิน 100 ตัวอักษร)",
  "main.foodmenu.addmenu.menu.titleEN": "ชื่อรายการภาษาอังกฤษ",
  "main.foodmenu.addmenu.menu.placeholderEN": "ใส่ชื่อรายการภาษาอังกฤษ (ไม่เกิน 100 ตัวอักษร)",
  "main.foodmenu.addmenu.menu.tips.title": "คำแนะนำการตั้งชื่อ\n      • ใช้ภาษาไทย ภาษาอังกฤษ หรือ ตัวเลขเท่านั้น\n      • สะกดคำให้ถูกต้อง\n      • ไม่ใช้สัญลักษณ์พิเศษหรืออิโมจิต่างๆ\n      • ไม่ใช้คำโปรยหรือคำโฆษณา\n      • ใช้ชื่อที่กระชับ ชัดเจน เข้าใจง่าย",
  "main.forgot.password.tips.header": "คำแนะนำการตั้งรหัสผ่าน",
  "main.forgot.password.tips.content1": "• มีความยาว 8-16 ตัว",
  "main.forgot.password.tips.content2": "• ประกอบด้วยอักษรภาษาอังกฤษตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และเครื่องหมายหรือ อักขระพิเศษ",
  "main.forgot.password.tips.content3": "• ไม่ใช้คำศัพท์ภาษาอังกฤษเป็นรหัสผ่าน",
  "main.forgot.password.tips.content4": "• ไม่ใช้คำที่ดัดแปลงจากคำอื่นเป็นรหัสผ่าน เช่น คำว่า zer0 (เปลี่ยน o เป็น 0)",
  "main.foodmenu.addmenu.menuSKUId.title": "SKU",
  "main.foodmenu.addmenu.menuSKUId.placeholder": "ใส่ SKU/รหัสอ้างอิงรายการ (ไม่เกิน 100 ตัวอักษร)",
  "main.foodmenu.addmenu.description.title": "คำอธิบาย",
  "main.foodmenu.addmenu.description.placeholder": "ใส่คำอธิบายรายการหรือรายละเอียดเพิ่มเติม\n(ไม่เกิน 200 ตัวอักษร)",
  "main.foodmenu.addmenu.description.titleEN": "คำอธิบายภาษาอังกฤษ",
  "main.foodmenu.addmenu.description.placeholderEN": "ใส่คำอธิบายรายการหรือรายละเอียดเพิ่มเติมภาษาอังกฤษ (ไม่เกิน 200 ตัวอักษร)",
  "main.foodmenu.addmenu.description.remarkEN": "หากไม่ระบุข้อมูลภาษาอังกฤษ ลูกค้าที่ใช้งานแอปเป็นภาษาอื่น\nจะเห็นชื่อและคำอธิบายรายการที่คุณระบุด้านบนแทน",
  "main.foodmenu.addmenu.prices.title": "ราคา (บาท)",
  "main.foodmenu.addmenu.prices.placeholder": "ใส่ราคา",
  "main.foodmenu.addmenu.prices.tips": "ใส่ราคาที่รวมภาษีและค่าบริการแล้ว",
  "main.foodmenu.addmenu.prices.validate": "รูปแบบไม่ถูกต้อง",
  "main.foodmenu.addmenu.picture.title": "รูป",
  "main.foodmenu.addmenu.picture.button.title": "เลือกรูป",
  "main.foodmenu.addmenu.picture.warning": "ไฟล์ .jpg หรือ .png ขนาดไม่เกิน 3MB",
  "main.foodmenu.addmenu.status.title": "สถานะรายการ",
  "main.foodmenu.addmenu.status.text.true": "แสดงรายการนี้บนหน้าจอแอปทุกสาขา",
  "main.foodmenu.addmenu.status.text.false": "ไม่แสดงรายการนี้บนหน้าจอแอปทุกสาขา",
  "main.foodmenu.addmenu.button.title.addDiscount": "เพิ่มส่วนลดเมนู",
  "main.foodmenu.addmenu.button.title.submit": "เพิ่ม",
  "main.foodmenu.addmenu.button.title.cancel": "ยกเลิก",
  "main.foodmenu.addmenu.description.warning": "*ห้ามจำหน่ายอาหาร/เครื่องดื่มที่มีส่วนผสมของ กัญชา,\nกระท่อม และสารเสพติดทุกประเภทโดยเด็ดขาด",
  "main.foodmenu.addmenu.form.error.notFoundCategory.title": "ไม่พบหมวดหมู่ที่คุณเลือก",
  "main.foodmenu.addmenu.form.error.notFoundCategory.content": "กรุณาเลือกหมวดหมู่อื่น หรือเพิ่มหมวดหมู่นี้ในร้านค้าของคุณก่อนเพิ่มรายการขาย",
  "main.foodmenu.addmenu.form.tag.isDeleted": "กรุณาเลือกประเภทใหม่อีกครั้ง",
  "main.foodmenu.addmenu.form.tag.placeholder": "เลือกประเภท",
  "main.foodmenu.addmenu.form.tag.isDeleted.placeholder": "เลือกประเภทอีกครั้ง",

  "main.foodmenu.addmenu.form.discount.title": "ส่วนลดเมนู",
  "main.foodmenu.addmenu.form.discount.description": "ส่วนลดของเมนูจะแสดงในช่วงวันที่และเวลาที่ขาย",
  "main.foodmenu.addmenu.form.discount.priceDiscount.label": "ราคาที่ลดแล้ว *",
  "main.foodmenu.addmenu.form.discount.discountPercent.label": "จำนวนเปอร์เซ็นต์ที่ลด",
  "main.foodmenu.addmenu.form.discount.startDateTime.label": "วันที่เริ่มโปรโมชัน",
  "main.foodmenu.addmenu.form.discount.startDate.label": "วันเริ่มต้น *",
  "main.foodmenu.addmenu.form.discount.startTime.label": "เวลาเริ่มต้น",
  "main.foodmenu.addmenu.form.discount.enablePromotionEndDateTime.label": "วัน-เวลาสิ้นสุดโปรโมชัน",
  "main.foodmenu.addmenu.form.discount.endDate.label": "วันสิ้นสุด *",
  "main.foodmenu.addmenu.form.discount.endTime.label": "เวลาสิ้นสุด",

  "main.foodmenu.deletemenu.userAction.title": "ต้องการลบส่วนลดเมนู?",
  "main.foodmenu.deletemenu.userAction.content": "ส่วนลดนี้จะไม่แสดงในเมนูนี้อีกต่อไป",
  "main.foodmenu.deletemenu.originalPriceChange.title": "ต้องการแก้ไขราคา",
  "main.foodmenu.deletemenu.originalPriceChange.content": "หากแก้ไขราคาเต็มส่วนลดจะถูกรีเซ็ต",

  "main.form.vatbranchno.valid": "ต้องเป็นตัวเลข 5 หลักเท่านั้น",
  "main.form.digit.only": "ต้องเป็นตัวเลขเท่านั้น",
  "main.form.email.valid": "โปรดกรอกอีเมลให้ถูกต้อง",
  "main.form.email.format.valid": "รูปแบบอีเมลไม่ถูกต้อง",
  "main.form.name.valid": "ต้องเป็นตัวอักษร ช่องว่าง หรือเครื่องหมาย - ( ) . เท่านั้น",
  "main.form.name.vat.valid": "ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' \" # & () @ + % . <> | ® / เท่านั้น",
  "main.form.required": "โปรดกรอกข้อมูล",
  "main.form.required2": "กรุณาใส่ข้อมูล",
  "main.form.text.valid": "ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' \" # & () @ + % . <> | ® / เท่านั้น",
  "main.form.text.validEN": "ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ - * ' \" # & () @ + % . <> | ® / เท่านั้น",
  "main.form.name.menu.valid": "ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' \" # & () @ + % . <> | ® / ! : ; เท่านั้น",
  "main.form.name.menu.validEN": "ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ - * ' \" # & () @ + % . <> | ® / ! : ; เท่านั้น",
  "main.form.name.shop.valid": "ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมายเท่านั้น",
  "main.form.name.shop.validEN": "ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมายเท่านั้น",
  "main.form.text.optional": "(ถ้ามี)",
  "main.form.maxlength": "ความยาวตัวอักษรเกินจำนวนที่กำหนด",
  "main.godemo": "ไปหน้าเดโม่",
  "main.main": "หน้าแรก",
  "main.modal_delete_confirm_branch_content": "คุณกำลังจะลบสาขานี้\nซึ่งจะทำให้ข้อมูลผู้จัดการสาขานี้ถูกลบไปด้วย\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.modal_delete_confirm_branch_header": "ยืนยันการลบสาขา",
  "main.modal_delete_confirm_header": "ยืนยันการลบรายการ",
  "main.modal_delete_confirm_vat_content": "ลบที่อยู่ใบกำกับภาษี",
  "main.model_dupilcation_menu_name_title": "ชื่ออาหารซ้ำ",
  "main.model_dupilcation_menu_name_content": "กรุณาตั้งชื่อใหม่",
  "main.model_delete_menu_title": "ยืนยันการลบรายการ",
  "main.model_delete_menu_content": "คุณกำลังจะลบรายการอาหารนี้\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.notavailable": "ไม่สามารถดำเนินการต่อได้",
  "main.of": "จาก",
  "main.register": "ตรวจสอบข้อมูล",
  "main.resapi": "ผล API : ",
  "main.retry": "กรุณาทำรายการใหม่อีกครั้ง",
  "main.showing": "กำลังแสดง",
  "main.systemnotavailable": "ระบบไม่สามารถทำรายการได้ในขณะนี้",
  "main.title": "Robinhood is here to help",
  "main.description.food": "ให้ Robinhood ช่วยคุณเพิ่มยอดขาย มาเปิดร้านออนไลน์กับเรา สมัครใช้บริการได้ง่าย ๆ เพียงใส่ข้อมูลร้านค้าตามขั้นตอนต่อไปนี้",
  "main.description.mart": "ให้ Robinhood ช่วยคุณเพิ่มยอดขายออนไลน์ จัดการร้านค้าของคุณผ่านระบบจัดการร้านค้าได้เลย",
  "main.card1": "1. เพิ่มข้อมูลสาขา",
  "main.card2": "2. กำหนดผู้จัดการสาขา",
  "main.card3": "3. เพิ่มที่อยู่ใบกำกับภาษี",
  "main.card4": "4. กำหนดที่อยู่ใบกำกับภาษีของสาขา",
  "main.card5": "5. สร้างหมวดหมู่",
  "main.card6": "6. สร้างรายการขาย",
  "main.card7": "รายงาน",
  // Confirm All Change
  "main.confirm_all_change.success.title": "ข้อมูลร้านค้าครบถ้วนแล้ว",
  "main.confirm_all_change.success.content": "ระบบได้ส่งอีเมลไปยังผู้จัดการสาขา กรุณาแจ้งผู้จัดการสาขาให้ตรวจสอบหมวดหมู่และรายการอาหารให้ถูกต้องครบถ้วน",
  "main.confirm_all_change.no_vat_address.title": "ข้อมูลร้านค้าไม่ครบถ้วน",
  "main.confirm_all_change.no_vat_address.content": "กรุณากำหนดที่อยู่ใบกำกับภาษีให้ครบถ้วน\nในขั้นตอนที่ 4",
  "main.confirm_all_change.no_menu.title": "ข้อมูลร้านค้าไม่ครบถ้วน",
  "main.confirm_all_change.no_menu.content": "กรุณาสร้างรายการอาหารให้ครบถ้วน\nในขั้นตอนที่ 6",
  // User
  "main.user.add": "เพิ่มผู้จัดการสาขา",
  "main.user.edit": "แก้ไขข้อมูลผู้จัดการสาขา",
  "main.user.empty.content": "เพิ่มผู้จัดการสาขาเป็นผู้ใช้งานแอปร้านค้าของคุณ",
  "main.user.empty.header": "ไม่มีข้อมูลผู้จัดการสาขา",
  "main.user.form.add.duplicated.email.modal.content": "อีเมลซ้ำกับอีเมลที่มีอยู่ในระบบ กรุณาใช้อีเมลอื่น",
  "main.user.form.add.duplicated.email.modal.title": "ไม่สามารถดำเนินการต่อได้",
  "main.user.form.add.manager.email": "ใส่อีเมล (ไม่เกิน 50 ตัวอักษร)",
  "main.user.form.add.manager.mobilenumber": "ใส่เบอร์โทรศัพท์",
  "main.user.form.add.manager.name": "ใส่ชื่อผู้จัดการสาขา (ไม่เกิน 50 ตัวอักษร)",
  "main.user.form.delete.confirm.content": "คุณกำลังจะลบผู้จัดการสาขานี้\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.user.form.delete.confirm.title": "ยืนยันการลบผู้จัดการสาขา",
  "main.user.form.status.active": "เปิดการใช้งาน",
  "main.user.form.status.inactive": "ปิดการใช้งาน",
  "main.user.manager.branch": "สาขา",
  "main.user.manager.email": "อีเมล",
  "main.user.manager.mobilenumber": "เบอร์โทรศัพท์",
  "main.user.manager.name": "ชื่อผู้จัดการสาขา",
  "main.user.manager.name.search": "ใส่ชื่อผู้จัดการสาขา",
  "main.user.status": "สถานะผู้ใช้",
  "main.user.status.active": "ใช้งานอยู่",
  "main.user.status.inactive": "ไม่ได้ใช้งาน",
  "main.user.usermanagement": "ผู้จัดการสาขา",
  "main.username": "ผู้ใช้งาน",
  "main.logout": "ออกจากระบบ",
  // Vat
  "main.vat.vatdelete": "ลบ",
  "main.vat_addaddress": "เพิ่มที่อยู่ใบกำกับภาษี",
  "main.vat_set_default": "กำหนดที่อยู่ใบกำกับภาษีเริ่มต้น",
  "main.vat_set_default.title": "กำหนดที่อยู่ใบกำกับภาษีเริ่มต้น",
  "main.vat_set_default.detail": "เลือกที่อยู่เริ่มต้นสำหรับใช้ออกใบกำกับภาษี โดยที่อยู่นี้จะถูกใช้เป็นที่อยู่ใบกำกับภาษีโดยอัตโนมัติ สำหรับสาขาที่คุณยังไม่ได้กำหนด",
  "main.vat_branchnum": "สาขาที่",
  "main.vat_deletecomfirm_content": "คุณกำลังจะลบที่อยู่ใบกำกับภาษีนี้\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.vat_deletecomfirm_header": "ยืนยันการลบที่อยู่",
  "main.vat_editaddress": "แก้ไขที่อยู่ใบกำกับภาษี",
  "main.vat_form_subdistrict": "เลือกแขวง",
  "main.vat_form_zipcode": "เลือกรหัสไปรษณีย์",
  "main.vat_inputvataddress": "ใส่ที่อยู่",
  "main.vat_inputvatbranchnumber": "ใส่เลขที่สาขา",
  "main.vat_inputvatdistrict": "เลือกเขต/อำเภอ",
  "main.vat_inputvatid": "ใส่เลขประจำตัวผู้เสียภาษี 13 หลัก",
  "main.vat_inputvatname": "ใส่ชื่อผู้เสียภาษี",
  "main.vat_inputvatprovince": "เลือกจังหวัด",
  "main.vat_validate": "ต้องเป็นตัวเลข 13 หลักเท่านั้น",
  "main.vat_vatadd": "เพิ่ม",
  "main.vat_vataddress": "ที่อยู่ใบกำกับภาษี",
  "main.vat_form_vataddress": "ที่อยู่เพื่อออกใบกำกับภาษี",
  "main.vat_vatbranchno": "สาขา",
  "main.vat_vatbranchno_radio": "สาขา",
  "main.vat_vatbranchno_mainbranch": "สำนักงานใหญ่ (00000)",
  "main.vat_vatbranchno.remark": "หมายเหตุ:",
  "main.vat_vatbranchno.remarkdesc": "สำนักงานใหญ่มีได้เพียงแห่งเดียว โดยมีเลขที่เป็น 00000 โดยอัตโนมัติ",
  "main.vat_vat_address_branch": "สาขาที่ใช้ที่อยู่นี้",
  "main.vat_vatid": "เลขประจำตัวผู้เสียภาษี",
  "main.vat_vatname": "ชื่อผู้เสียภาษี",
  "main.vat_vatpostalcode": "รหัสไปรษณีย์",
  "main.vat_vatsubdistrict": "แขวง/ตำบล",
  "main.vat_vatdistrict": "เขต/อำเภอ",
  "main.vat_vatsubdistrict.desc": "ใส่แขวง/ตำบล",
  "main.vat_vatdistrict.desc": "ใส่เขต/อำเภอ",
  "main.vat_vatprovince": "จังหวัด",
  "main.vat_vatbranchno_mainbranchonly_inline_error": "เลขที่สาขานี้ใช้สำหรับสำนักงานใหญ่เท่านั้น",
  "main.vat_addressdetail_inline_error": "ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' \" # & () @ + % . , <> | ® / เท่านั้น",
  "main.vat_error_duplicatedHQ": "สำนักงานใหญ่มีได้เพียงแห่งเดียว\nคุณสามารถกลับไปแก้ไขที่อยู่ของสำนักงานใหญ่\nหรือเลือกเป็นสาขาเพื่อดำเนินการต่อ",
  "main.vat_error_duplicatedVatAddress": "มีข้อมูลที่อยู่ใบกำกับภาษีนี้ในระบบแล้ว\nกรุณาตรวจสอบอีกครั้ง",
  "main.vat_error_deleteMappedShop": "มีสาขาที่ใช้ที่อยู่นี้เพื่อออกใบกำกับภาษี\nหากต้องการลบ กรุณาเปลี่ยนที่อยู่ของสาขาก่อน",
  "main.vat_error_deleteLastOneOrDefault": "ต้องมีที่อยู่เพื่อออกใบกำกับภาษีอย่างน้อย 1 ที่อยู่\nและไม่สามารถลบที่อยู่เริ่มต้นได้",
  "main.vat_vat_default_tag": "ที่อยู่เริ่มต้น",
  "main.vat_delete_vat_success": "ลบที่อยู่ใบกำกับภาษีสำเร็จแล้ว",
  "main.vat_delete_vat_not_success": "ลบที่อยู่ใบกำกับภาษีไม่สำเร็จ",
  "main.inline.validate.phonenumber": "ต้องเป็นตัวเลข 9 หรือ 10 หลักเท่านั้น",
  "main.vat.index.vatid": "เลขประจำตัวผู้เสียภาษี",
  "main.vat.index.vatname": "ชื่อผู้เสียภาษี",
  "main.vat.index.editvat": "แก้ไขข้อมูลผู้เสียภาษี",
  "main.vat_taxes_vat_success": "แก้ไขข้อมูลผู้เสียภาษีสำเร็จแล้ว",
  "main.vat_taxes_vat_fail": "แก้ไขข้อมูลผู้เสียภาษีไม่สำเร็จ",
  "main.error.vat.vatAddressDetail.maxlength": "ต้องมีความยาวไม่เกิน 150 ตัวอักษร",
  // Category
  "main.cat_addcat": "เพิ่มหมวดหมู่",
  "main.cat_category": "หมวดหมู่ และเมนู",
  "main.cat_category_name": "ชื่อหมวดหมู่",
  "main.cat_category_name_en": "ชื่อหมวดหมู่ภาษาอังกฤษ",
  "main.cat_category_name_dup": "ชื่อหมวดหมู่ซ้ำ",
  "main.cat_category.category_tab.header": "หมวดหมู่ทั้งหมด",
  "main.cat_category_rename": "ชื่อหมวดหมู่ซ้ำ กรุณาตั้งชื่อใหม่",
  "main.cat_category_edit": "แก้ไขหมวดหมู่",
  "main.cat_category_remark_en": "หากไม่ระบุข้อมูลภาษาอังกฤษ ลูกค้าที่ใช้งานแอปเป็นภาษาอื่น\nจะเห็นชื่อหมวดหมู่ที่คุณระบุด้านบนแทน",
  "main.cat_category.edit.alert.success": "แก้ไขหมวดหมู่ “{categoryName}” สำเร็จ",
  "main.cat_category.edit.alert.failure": "แก้ไขหมวดหมู่ “{categoryName}” ไม่สำเร็จ",
  "main.cat_category_delete_header": "ยืนยันการลบหมวดหมู่",
  "main.cat_category_delete_content": "การลบหมวดหมู่จะทำให้\nรายการขายทั้งหมดในหมวดหมู่นี้ถูกลบไปด้วย\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.cat_category.delete.alert.success": "ลบหมวดหมู่สำเร็จแล้ว",
  "main.cat_category.delete.alert.failure": "ลบหมวดหมู่ไม่สำเร็จ กรุณาลองอีกครั้ง",
  "main.cat_category_name_placeholder": "ใส่ชื่อหมวดหมู่ (ไม่เกิน 50 ตัวอักษร)",
  "main.cat_category_name_placeholder_en": "ใส่ชื่อหมวดหมู่ภาษาอังกฤษ (ไม่เกิน 50 ตัวอักษร)",
  "main.cat_category_search_placeholder": "ใส่ชื่อหมวดหมู่",
  "main.cat_category.table.title.name_th": "ชื่อหมวดหมู่ (ไทย)",
  "main.cat_category.table.title.name_en": "ชื่อหมวดหมู่ (อังกฤษ)",
  "main.cat_category.table.title.menu_count": "จำนวนเมนู",
  "main.button_create": "เพิ่ม",
  "main.cat_tooltip_header": "คำแนะนำการตั้งชื่อ",
  "main.cat_tooltip_content_1": "ใช้ภาษาไทย ภาษาอังกฤษ หรือตัวเลขเท่านั้น",
  "main.cat_tooltip_content_2": "สะกดคำให้ถูกต้อง",
  "main.cat_tooltip_content_3": "ไม่ใช้สัญลักษณ์พิเศษหรืออิโมจิต่างๆ",
  "main.cat_tooltip_content_4": "ไม่ใช้คำโปรยหรือคำโฆษณา",
  "main.cat_tooltip_content_5": "ใช้ชื่อที่กระชับ ชัดเจน เข้าใจง่าย",
  // Report landing
  "main.report": "รายงาน",
  "main.report_desc1": "รหัสเปิดไฟล์รายงานคือ",
  "main.report_desc2": "เลขประจำตัวผู้เสียภาษี 6 หลักสุดท้ายของคุณ",
  "main.report_form_date": "วันที่ออกรายงาน",
  "main.report_form_branch": "สาขา",
  "main.report_option_all": "ทุกสาขา",
  "main.report_button_search": "ค้นหารายงาน",
  "main.report.table.column1": "วันที่ออกรายงาน",
  "main.report.table.column2": "สาขาตามใบกำกับภาษี",
  "main.report.table.column3": "สาขา",
  "main.report.table.column4": "วิธีออกรายงาน",
  "main.report.table.column5": "ประเภทรายงาน",
  "main.report.table.column6": "ชื่อรายงาน",
  "main.report.table.column7": "ดาวน์โหลด",
  "main.table.notFound": "ไม่พบข้อมูล",
  "main.report.remark": "หมายเหตุ : รายงานการขายล่าสุด จะดาวน์โหลดได้ภายใน {date} วัน หากไม่พบข้อมูล กรุณาลองใหม่อีกครั้งในวันถัดไป",
  "main.report.pagination": "แสดง {range1}-{range2} จาก {total} รายการ",
  "main.report.tooltip.header": "ชื่อรายงานขึ้นต้นด้วย",
  "main.report.tooltip.content1": "• STM คือ รายการเดินบัญชี",
  "main.report.tooltip.content2": "• TNV คือ ใบแจ้งหนี้/ใบเสร็จรับเงิน",
  "main.report.tooltip.content3": "• RNV คือ ใบแจ้งหนี้/ใบเสร็จรับเงิน (ทดแทน)",
  "main.report.tooltip.content4": "• CDN คือ ใบลดหนี้",
  "main.report.tooltip.content5": "• RCN คือ ใบลดหนี้ (ทดแทน)",
  "main.report.tooltip.report_type_header": "วิธีออกรายงาน",
  "main.report.tooltip.report_type1": " • แบบที่ 1 : แยกรายงานเดินบัญชี\n   และใบแจ้งหนี้/ใบเสร็จรับเงิน\n   ของแต่ละสาขา",
  "main.report.tooltip.report_type2": " • แบบที่ 2 : รวมรายงานเดินบัญชีทุกสาขา\n   และแยกใบแจ้งหนี้/ใบเสร็จรับเงิน\n   ตามที่อยู่ใบกำกับภาษี",
  "main.report.type.stm": "รายการเดินบัญชี",
  "main.report.type.tnv": "ใบแจ้งหนี้/ใบเสร็จรับเงิน",
  "main.report.type.rnv": "ใบแจ้งหนี้/ใบเสร็จรับเงิน (ทดแทน)",
  "main.report.type.cdn": "ใบลดหนี้",
  "main.report.type.rcn": "ใบลดหนี้ (ทดแทน)",
  "main.report.manage.report.email.btn": "จัดการอีเมลรับรายงาน",
  "main.report.pickReport.btn": "เลือกวิธีออกรายงาน",
  "main.report.pickReport.popup.header": "เลือกวิธีออกรายงาน",
  "main.report.pickReport.popup.desc": "การเปลี่ยนวิธีออกรายงานจะมีผลทันที",
  "main.report.pickReport.popup.type1": "แบบที่ 1 : แยกรายการเดินบัญชี และใบแจ้งหนี้/ใบเสร็จรับเงิน ของแต่ละสาขา",
  "main.report.pickReport.popup.type1.desc": "ตัวอย่าง หากในระบบมี 10 สาขา และ 5 ที่อยู่ใบกำกับภาษี คุณจะได้รับเอกสารต่อไปนี้ทางอีเมล",
  "main.report.pickReport.popup.type1.desc2": "• รายการเดินบัญชี 10 ฉบับ",
  "main.report.pickReport.popup.type1.desc3": "• ใบแจ้งหนี้/ใบเสร็จรับเงิน 10 ฉบับ",
  "main.report.pickReport.popup.type2": "แบบที่ 2 : รวมรายการเดินบัญชีทุกสาขา และแยกใบแจ้งหนี้/ใบเสร็จรับเงิน ตามที่อยู่ใบกำกับภาษี",
  "main.report.pickReport.popup.type2.desc": "ตัวอย่าง หากในระบบมี 10 สาขา และ 5 ที่อยู่ใบกำกับภาษี คุณจะได้รับเอกสารต่อไปนี้ทางอีเมล",
  "main.report.pickReport.popup.type2.desc2": "• รายการเดินบัญชีรวมทุกสาขา 1 ฉบับ",
  "main.report.pickReport.popup.type2.desc3": "• ใบแจ้งหนี้/ใบเสร็จรับเงิน 5 ฉบับ",
  "main.report.pickReport.popup.remark": "เนื่องจากระบบจะปิดปรับปรุงข้อมูลระหว่างเวลา {batchReportStart} - {batchReportEnd} น. ของทุกวัน จึงไม่สามารถเปลี่ยนวิธีการออก\nรายงานในช่วงเวลาดังกล่าวได้",
  "main.report.pickReport.alert.success": "เปลี่ยนวิธีออกรายงานเป็นแบบที่ {reportTypeSelected} แล้ว",
  "main.report.pickReport.alert.fail": "เปลี่ยนวิธีการออกรายงานไม่สำเร็จ",
  "main.report.pickReport.popup.content.batchError": "เนื่องจากระบบจะปิดปรับปรุงข้อมูลระหว่างเวลา {batchReportStart} - {batchReportEnd} น. ของทุกวัน จึงไม่สามารถเปลี่ยนวิธีการออกรายงานในช่วงเวลาดังกล่าวได้",
  // Report ManageEmail
  "main.report.manageEmail.breadcrumb.manageEmail": "จัดการอีเมลรับรายงาน",
  "main.report.manageEmail.header.manageEmail": "จัดการอีเมลรับรายงาน",
  "main.report.manageEmail.remark": "หมายเหตุ:",
  "main.report.manageEmail.remark1": "1. หากเปลี่ยนอีเมลใหม่เพื่อใช้รับรายงาน จะต้องยืนยันอีเมลนั้นก่อนจึงจะสามารถใช้งานได้",
  "main.report.manageEmail.remark2": "2. ระบบจะส่งอีเมลที่มีลิงก์ยืนยันไปยังอีเมลใหม่ของคุณ กรุณากดลิงก์ยืนยันภายใน 24 ชั่วโมง",
  "main.report.manageEmail.remark3": "3. หากอีเมลยืนยันที่คุณได้รับหมดอายุ กรุณาขออีเมลยืนยันใหม่",
  "main.report.manageEmail.remark4": "4. รายงานจะถูกส่งไปยังอีเมลเดิมจนกว่าอีเมลใหม่จะได้รับการยืนยัน",
  "main.report.manageEmail.table.vat.column1": "ที่อยู่เพื่อออกใบกำกับภาษี",
  "main.report.manageEmail.table.vat.column2": "อีเมลรับรายงาน",
  "main.report.manageEmail.table.vat.column3": "สถานะอีเมล",
  "main.report.manageEmail.table.vat.column4": "อีเมลยืนยัน",
  "main.report.manageEmail.table.vat.column1.value": "ทุกที่อยู่",
  "main.report.manageEmail.table.vat.tag.verified": "ยืนยันแล้ว",
  "main.report.manageEmail.table.vat.tag.pending": "รอการยืนยัน",
  "main.report.manageEmail.table.vat.tag.expired": "อีเมลยืนยันหมดอายุ",
  "main.report.manageEmail.table.vat.header": "อีเมลรับรายงาน (ตามที่อยู่ใบกำกับภาษี)",
  "main.report.manageEmail.table.vat.content1": "สามารถกำหนดอีเมลรับรายงานตามที่อยู่ใบกำกับภาษีได้สูงสุด 2 อีเมล (รวมทุกที่อยู่)",
  "main.report.manageEmail.table.vat.content2": "หากแก้ไขอีเมลแล้ว แต่อีเมลนั้นยังไม่ได้รับการยืนยัน รายงานจะถูกส่งไปยังอีเมลเดิม",
  "main.report.manageEmail.table.vat.btn.editEmail": "แก้ไขอีเมล",
  "main.report.manageEmail.table.shop.header": "อีเมลรับรายงาน (ตามสาขา)",
  "main.report.manageEmail.table.shop.content1": "แต่ละสาขาสามารถมีอีเมลรับรายงานได้สูงสุด 2 อีเมล",
  "main.report.manageEmail.table.shop.content2": "หากแก้ไขอีเมลแล้ว แต่อีเมลนั้นยังไม่ได้รับการยืนยัน รายงานจะถูกส่งไปยังอีเมลเดิม",
  "main.report.manageEmail.resendEmail": "ขออีเมลยืนยันใหม่",
  "main.report.manageEmail.table.vat.email1": "อีเมล 1",
  "main.report.manageEmail.table.vat.email2": "อีเมล 2",
  "main.report.manageEmail.table.shop.email1": "อีเมล 1",
  "main.report.manageEmail.table.shop.email2": "อีเมล 2",
  "main.report.manageEmail.table.shop.column1": "สาขา",
  "main.report.manageEmail.table.shop.column2": "อีเมลรับรายงาน",
  "main.report.manageEmail.table.shop.column3": "สถานะอีเมล",
  "main.report.manageEmail.table.shop.tag.verified": "ยืนยันแล้ว",
  "main.report.manageEmail.table.shop.tag.pending": "รอการยืนยัน",
  "main.report.manageEmail.table.shop.tag.expired": "อีเมลยืนยันหมดอายุ",
  "main.report.manageEmail.table.vat.column2.value.previousEmailCc": "(อีเมลเดิม {email})",
  "main.report.manageEmail.table.vat.editEmail.btn": "แก้ไขอีเมล",
  "main.report.manageEmail.table.shop.editEmail.btn": "แก้ไขอีเมล",
  "main.report.manageEmail.alert.success": "บันทึกอีเมลรับรายงานแล้ว หากมีการเปลี่ยนอีเมลใหม่ คุณจะได้รับอีเมลยืนยันจากระบบ",
  "main.report.manageEmail.resend.popup.header": "ขออีเมลยืนยันใหม่สำเร็จ",
  "main.report.manageEmail.resend.popup.content": "ระบบจะส่งอีเมลที่มีลิงก์ยืนยันไปยังอีเมลใหม่ของคุณ\nกรุณากดลิงก์ยืนยันภายใน 24 ชั่วโมง",
  "main.report.manageEmail.resend.popup.ok": "ตกลง",
  // Report AddEditEmailVat
  "main.report.addEditEmailVat.breadcrumb.editEmail": "แก้ไขอีเมล",
  "main.report.addEditEmailVat.header.editEmail": "แก้ไขอีเมล",
  "main.report.addEditEmailVat.table.vat.column1": "ที่อยู่เพื่อออกใบกำกับภาษี",
  "main.report.addEditEmailVat.table.vat.column2": "อีเมล 1",
  "main.report.addEditEmailVat.table.vat.column3": "อีเมล 2",
  "main.report.addEditEmailVat.table.vat.content": "คุณจะไม่สามารถเปลี่ยนแปลงข้อมูลอีเมล 1 ได้",
  "main.report.addEditEmailVat.table.vat.column2.emailTo.placeholder": "ใส่อีเมล 1",
  "main.report.addEditEmailVat.table.vat.column3.emailCc.placeholder": "ใส่อีเมล 2",
  "main.report.addEditEmailVat.okButton": "บันทึก",
  "main.report.addEditEmailVat.cancelButton": "ยกเลิก",
  "main.report.addEditEmail.error.dupEmail": "ไม่สามารถใส่อีเมลซ้ำกับอีเมล 1 ได้",
  // Report AddEditEmailShop
  "main.report.addEditEmailShop.breadcrumb.editEmail": "แก้ไขอีเมล",
  "main.report.addEditEmailShop.header.editEmail": "แก้ไขอีเมล",
  "main.report.addEditEmailShop.table.shop.column1": "สาขา",
  "main.report.addEditEmailShop.table.shop.column2": "อีเมล 1",
  "main.report.addEditEmailShop.table.shop.column3": "อีเมล 2",
  "main.report.addEditEmailShop.email1.required": "กรุณาใส่อีเมล 1",
  // Error
  "main.error.timeout.title": "ไม่สามารถดำเนินการต่อได้",
  "main.error.timeout.content": "คุณไม่ได้ทำรายการในเวลาที่กำหนด หรือได้ออกจากระบบแล้ว โปรด Login อีกครั้ง",
  //TNC Modal
  "main.modal.tnc.title": "ข้อกำหนดและเงื่อนไขการใช้บริการร้านค้าโรบินฮู้ด",
  "main.modal.tnc.button.cancel": "ไม่ยอมรับ",
  "main.modal.tnc.button.confirm": "ยอมรับ",
  // Logistic
  "main.modal.logistic.title": "ผู้ส่งอาหารซึ่งเป็นพันธมิตรของบริษัท",
  "main.modal.logistic.description": "ผู้ขอใช้บริการตกลงใช้บริการ/จ้างส่งอาหารจาก",
  "main.modal.logistic.message": "ผู้ขอใช้บริการได้อ่านและตกลงยอมรับตามข้อกำหนดและเงื่อนไขการส่งอาหารของ",
  "main.modal.logistic.detail": "ผู้ขอใช้บริการตกลงให้ผู้ดูแลระบบของผู้ขอใช้บริการในแพลตฟอร์ม มีอำนาจทำรายการการใช้บริการ และ/หรือ กระทำการใด ๆ แทนผู้ขอใช้บริการ รวมถึงแต่ไม่จำกัดเฉพาะการตกลงใช้บริการ/จ้างส่งอาหารจากพันธมิตรผู้ส่งอาหาร ผ่านแพลตฟอร์ม",
  "main.modal.logistic.linkable": "อ่านเพิ่มเติม",
  "main.modal.logistic.confirm.button": "ตกลง",
  //mainMaintenance
  "mainMaintenanceText1": "ปิดบริการชั่วคราว",
  "mainMaintenanceText2": "ขอแจ้งปิดบริการชั่วคราวเพื่อพัฒนาระบบ",
  "mainMaintenanceText3": "ขออภัยในความไม่สะดวก",
  //browserNotSupported
  "browserNotSupportedText1": "อัปเดตเว็บเบราว์เซอร์",
  "browserNotSupportedText2": "กรุณาใช้ Chrome หรือ Firefox เวอร์ชันล่าสุด",
  "browserNotSupportedText3": "หรือ Safari เวอร์ชัน 13 ขึ้นไป",
  // list view modal
  "main.modal.listview.title": "สาขาที่ใช้ที่อยู่นี้",
  // POS Management
  // POS Management landing
  "main.posManagement.landing.posManagement": "จัดการ POS",
  "main.posManagement.landing.remark": "หมายเหตุ: ระบบจะส่งคำสั่งซื้อไปยัง POS ตั้งแต่เที่ยงคืนของวันที่เริ่มใช้งาน",
  "main.posManagement.landing.table.posStatus": "สถานะ POS",
  "main.posManagement.landing.posStatus.tag.ps01": "ยังไม่เปิดใช้งาน",
  "main.posManagement.landing.posStatus.link.ps01": "เปิดใช้งาน POS",
  "main.posManagement.landing.posStatus.tag.ps02": "กำลังเปิดใช้งาน",
  "main.posManagement.landing.posStatus.link.ps02": "ดำเนินการต่อ",
  "main.posManagement.landing.posStatus.tag.ps03.withDate": "เริ่มใช้งาน {date}",
  "main.posManagement.landing.posStatus.link.ps03.withDate": "แก้ไขวันเปิดใช้งาน",
  "main.posManagement.landing.posStatus.tag.ps03.noDate": "เปิดใช้งานแล้ว",
  "main.posManagement.landing.posStatus.link.ps03.noDate": "ดูรายละเอียด",
  "main.posManagement.landing.posStatus.tag.ps04": "เปิดใช้งานไม่สำเร็จ",
  "main.posManagement.landing.posStatus.link.ps04": "แก้ไขข้อมูล",
  "main.posManagement.landing.headerDesc.text1": "ดูวิธีเปิดใช้งาน POS ได้",
  "main.posManagement.landing.headerDesc.text2": "ที่นี่",
  "main.posManagement.landing.popup.posDetail.header": "รายละเอียด POS",
  "main.posManagement.landing.popup.posDetail.label1": "ชื่อร้านและสาขา",
  "main.posManagement.landing.popup.posDetail.label2": "รหัสร้านค้า",
  "main.posManagement.landing.popup.posDetail.label3": "รหัสอ้างอิงสาขา",
  "main.posManagement.landing.popup.posDetail.label4": "ผู้ให้บริการ POS",
  "main.posManagement.landing.popup.posDetail.label5": "รหัสอ้างอิง POS",
  "main.posManagement.landing.popup.posDetail.label6": "วันที่เริ่มใช้งาน",
  "main.posManagement.landing.alert.cancelPos.success": "ยกเลิกการเปิดใช้งาน POS แล้ว",
  "main.posManagement.landing.alert.cancelPos.fail": "ยกเลิกการเปิดใช้งาน POS ไม่สำเร็จ",
  "main.posManagement.landing.alert.deActivatePos.success": "ยกเลิกการใช้งาน POS แล้ว",
  "main.posManagement.landing.alert.deActivatePos.fail": "ยกเลิกการใช้งาน POS ไม่สำเร็จ",
  // POS Management middle text
  "main.posManagement.breadcrumb.activate.pos": "เปิดใช้งาน POS",
  "main.posManagement.posActivate.cancelActivatePos": "ยกเลิกการเปิดใช้งาน POS",
  "main.posManagement.posActivate.cancelPos": "ยกเลิกการใช้งาน POS",
  "main.posManagement.posActivate.step1.1": "ใส่รหัสอ้างอิงรายการ",
  "main.posManagement.posActivate.step1.2": "อาหาร",
  "main.posManagement.posActivate.step2": "ใส่รหัสอ้างอิงตัวเลือก",
  "main.posManagement.posActivate.step3.1": "ตรวจสอบรหัสอ้างอิง",
  "main.posManagement.posActivate.step3.2": "สาขาและ POS",
  "main.posManagement.posActivate.step4": "กำหนดวันเปิดใช้งาน POS",
  "main.posManagement.posActivate.popup.noFoodFound.header": "ไม่พบรายการอาหาร",
  "main.posManagement.posActivate.popup.noFoodFound.content": "กรุณาสร้างรายการอาหารอย่างน้อย 1 รายการ\nเพื่อเริ่มใช้งาน POS",
  "main.posManagement.posActivate.popup.branchInProgress.content": "มีสาขาอื่นกำลังอยู่ในขั้นตอนการเปิดใช้งาน POS\nกรุณาเปิดใช้งาน POS ของสาขานั้นให้เสร็จก่อน",
  "main.posManagement.posActivate.popup.backToPrevious.header": "คุณกำลังจะกลับไปหน้าที่แล้ว",
  "main.posManagement.posActivate.popup.backToPrevious.content": "ก่อนออกจากหน้านี้ คุณต้องการบันทึกข้อมูลหรือไม่",
  "main.posManagement.posActivate.popup.backToPrevious.onOk": "บันทึก",
  "main.posManagement.posActivate.popup.backToPrevious.onCancel": "ไม่บันทึก",
  "main.posManagement.posActivate.buttonBackToPrevious": "กลับไปหน้าที่แล้ว",
  "main.posManagement.posActivate.shopNameLabel": "ชื่อร้านและสาขา :",
  "main.posManagement.posActivate.popup.deactivatePos.header": "ยกเลิกการใช้งาน POS",
  "main.posManagement.posActivate.popup.deactivatePos.content": "การใช้งาน POS จะถูกยกเลิกทันที\nร้านค้าจะไม่สามารถรับคำสั่งซื้อผ่านทาง POS ได้\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.posManagement.posActivate.popup.deactivatePos.ok": "ตกลง",
  "main.posManagement.posActivate.popup.deactivatePos.cancel": "ไม่ใช่ตอนนี้",
  "main.posManagement.posActivate.popup.cancelPos.header": "ยกเลิกการเปิดใช้งาน POS",
  "main.posManagement.posActivate.popup.cancelPos.content": "คุณต้องการดำเนินการต่อหรือไม่",
  "main.posManagement.posActivate.popup.cancelPos.ok": "ตกลง",
  "main.posManagement.posActivate.popup.cancelPos.cancel": "ไม่ใช่ตอนนี้",
  // POS Management posActivate Step 1
  "main.posManagement.posActivate.step1.foodmenu.landing.table.name": "ชื่ออาหาร",
  "main.posManagement.posActivate.table.menuSku": "รหัสอ้างอิงรายการอาหาร",
  "main.posManagement.posActivate.menuSkuLabel": "ใส่รหัสอ้างอิงรายการอาหาร",
  "main.posManagement.posActivate.menuSkuDesc": "กรุณาใส่รหัสอ้างอิงให้ครบทุกรายการ คุณสามารถแก้ไขรหัสทางเว็บไซต์และแอปพลิเคชันได้ภายหลัง",
  "main.posManagement.posActivate.buttonSaveOnly": "บันทึกข้อมูลหน้านี้",
  "main.posManagement.posActivate.buttonSaveAndNext": "บันทึกและถัดไป",
  "main.posManagement.posActivate.popup.leaveConfirm.header": "คุณกำลังออกจากการเปิดใช้งาน POS",
  "main.posManagement.posActivate.popup.leaveConfirm.content": "กรุณาเลือกวิธีดำเนินการต่อ",
  "main.posManagement.posActivate.popup.leaveConfirm.button.saveAndLeave": "บันทึกและออกจากหน้านี้",
  "main.posManagement.posActivate.popup.leaveConfirm.button.leaveOnly": "ออกโดยไม่บันทึกหน้านี้",
  "main.posManagement.posActivate.step1.alert.success": "บันทึกข้อมูลสำเร็จแล้ว",
  "main.posManagement.posActivate.popup.noFoodFound.button.toFoodMenu": "สร้างรายการอาหาร",
  "main.posManagement.posActivate.popup.noFoodFound.button.cancel": "ยกเลิก",
  // POS Management posActivate Step 2
  "main.posManagement.posActivate.step2.contentTitle": "ใส่รหัสอ้างอิงตัวเลือก",
  "main.posManagement.posActivate.step2.contentDetail": "กรุณาใส่รหัสอ้างอิงตัวเลือก หากไม่ใส่รหัส ตัวเลือกจะไม่ถูกแสดงบน POS คุณสามารถแก้ไขรหัสทางแอปพลิเคชันได้ภายหลัง",
  "main.posManagement.posActivate.step2.table.menuModifierName": "ชื่อตัวเลือก",
  "main.posManagement.posActivate.step2.table.menuModifierPrice": "ราคา (บาท)",
  "main.posManagement.posActivate.step2.table.menuModifierSku": "รหัสอ้างอิงตัวเลือก",
  "main.posManagement.posActivate.step2.table.notFound": "ร้านของคุณไม่มีตัวเลือก",
  "main.posManagement.posActivate.step2.table.form.menuModifier.placeholder": "ใส่รหัสอ้างอิงตัวเลือก (ไม่เกิน 100 ตัวอักษร)",
  "main.posManagement.posActivate.step2.button.next": "ถัดไป",
  // POS Management posActivate Step 3
  "main.posManagement.posActivate.contentTitle": "ตรวจสอบรหัสอ้างอิงสาขาและรหัสอ้างอิง POS",
  "main.posManagement.posActivate.contentDetail": "กรุณาใส่รหัสอ้างอิงสาขาและ POS เพื่อให้ระบบตรวจสอบ หากไม่มีรหัสอ้างอิง POS กรุณาสมัครใช้งาน หรือติดต่อขอรหัสจากผู้ให้บริการ POS",
  "main.posManagement.posActivate.shopId": "รหัสร้านค้า",
  "main.posManagement.posActivate.shopBranchCode": "รหัสอ้างอิงสาขา",
  "main.posManagement.posActivate.shopBranchCodePlaceholder": "ใส่รหัสอ้างอิงสาขา",
  "main.posManagement.posActivate.providerName": "ผู้ให้บริการ POS",
  "main.posManagement.posActivate.providerNamePlaceholder": "เลือกผู้ให้บริการ POS",
  "main.posManagement.posActivate.posReferenceId": "รหัสอ้างอิง POS",
  "main.posManagement.posActivate.posReferenceIdPlaceholder": "ใส่รหัสอ้างอิง POS",
  "main.posManagement.posActivate.popup.posUnverified.header": "ข้อมูลไม่ถูกต้อง",
  "main.posManagement.posActivate.popup.posUnverified.content": "กรุณาตรวจสอบข้อมูลอีกครั้ง\nหรือติดต่อผู้ให้บริการ POS ของคุณ",
  "main.posManagement.posActivate.buttonSaveAndVerify": "บันทึกและตรวจสอบ",
  // POS Management posActivate Step 4
  "main.posManagement.posActivate.buttonSaveThisPage": "บันทึกข้อมูลหน้านี้",
  "main.posManagement.posActivate.step4.contentTitle": "ข้อมูลถูกต้อง",
  "main.posManagement.posActivate.step4.contentDetail": "กรุณาเลือกวันที่ต้องการเปิดใช้งาน POS",
  "main.posManagement.posActivate.step4.contentDetail2": "ระบบจะส่งคำสั่งซื้อไปยัง POS ตั้งแต่เที่ยงคืนของวันที่เริ่มใช้งาน",
  "main.posManagement.posActivate.step4.calendarPlaceholder": "เลือกวันเปิดใช้งาน POS",
  // Confirm email
  "main.confirmEmail.success.title": "อีเมลของคุณ\nได้รับการยืนยันแล้ว",
  "main.confirmEmail.success.desc": "คุณจะได้รับรายงานประจำวันผ่านอีเมลนี้\nตั้งแต่วันนี้เป็นต้นไป",
  "main.confirmEmail.expired.title": "อีเมลยืนยันหมดอายุ",
  "main.confirmEmail.expired.desc": "กรุณาติดต่อผู้ดูแลระบบ\nเพื่อขออีเมลยืนยันใหม่",
  "main.confirmEmail.alreadyVerified.title": "อีเมลของคุณ\nได้รับการยืนยันแล้ว",
  "main.confirmEmail.alreadyVerified.desc": "กรุณาติดต่อผู้ดูแลระบบ\nเพื่อตรวจสอบสถานะ",
  "main.confirmEmail.error.title": "ไม่สามารถดำเนินการต่อได้",
  "main.confirmEmail.error.desc": "เกิดข้อผิดพลาดบางประการ\nหรือระบบอยู่ระหว่างปรับปรุงข้อมูล\nเวลา 23:00 - 01:00 น.\n\nกรุณาลองอีกครั้ง",
  // martCategory
  "main.mart.category.landing.breadcrumb": "หมวดหมู่",
  "main.mart.category.landing.header": "หมวดหมู่",
  "main.mart.category.landing.table.column1": "ชื่อหมวดหมู่",
  "main.mart.category.landing.table.column2": "ย้ายรายการ",
  "main.mart.category.landing.table.column3": "ลบ",
  "main.mart.category.landing.table.column1.search": "ใส่ชื่อหมวดหมู่",
  "main.mart.category.landing.btn.addMartCategory": "เพิ่มหมวดหมู่",
  "main.mart.category.add.martCategory": "หมวดหมู่",
  "main.mart.category.add.addMartCategory": "เพิ่มหมวดหมู่",
  "main.mart.category.add.header": "เพิ่มหมวดหมู่",
  "main.mart.category.add.field.category.label": "หมวดหมู่รายการขาย",
  "main.mart.category.add.field.category.placeholder": "เลือกหมวดหมู่ที่ต้องการเพิ่มไปยังร้านค้า",
  "main.mart.category.add.field.category.desc": "เพิ่มหลายหมวดหมู่พร้อมกันได้",
  "main.mart.category.add.btn.cancel": "ยกเลิก",
  "main.mart.category.add.btn.addCategory": "เพิ่ม",
  "main.mart.category.error.added.title": "ไม่สามารถดำเนินการต่อได้",
  "main.mart.category.error.added.desc": "คุณได้เพิ่มหมวดหมู่ครบทั้งหมดแล้ว",
  // martProduct
  "main.mart.product.landing.breadcrumb": "รายการขาย",
  "main.mart.product.landing.header": "รายการขาย",
  "main.mart.product.landing.subtitle": "สำหรับรายการใหม่ หรือรายการที่ไม่ผ่านอนุมัติ สถานะรายการบนแอปจะเปลี่ยนเป็นขายได้ เมื่อรายการได้รับการอนุมัติแล้ว",
  "main.mart.product.landing.empty.header": "ไม่มีรายการขาย",
  "main.mart.product.landing.empty.desc": "เพิ่มหมวดหมู่และรายการเพื่อเริ่มการขาย",
  "main.mart.product.landing.table.productStatus.active": "แสดงรายการ",
  "main.mart.product.landing.table.productStatus.inactive": "ไม่แสดงรายการ",
  "main.mart.product.landing.table.name.search.placeholder": "ใส่ชื่อรายการ",
  "main.mart.product.landing.table.productName": "ชื่อรายการ",
  "main.mart.product.landing.table.originalProductPrice": "ราคาเต็ม (บาท)",
  "main.mart.product.landing.table.productPrice": "ราคาลด (บาท)",
  "main.mart.product.landing.table.productCategory": "หมวดหมู่",
  "main.mart.product.landing.table.productStatus": "สถานะรายการ",
  "main.mart.product.landing.table.productEdit": "แก้ไข",
  "main.mart.product.landing.table.productDelete": "ลบ",
  "main.mart.product.landing.table.promotionPeriod": "เริ่ม {startDateTime} ถึง {endDateTime}",
  "main.mart.product.landing.table.promotionPeriodInfo.tooltip.content1": "ราคาที่ลดแล้วจะแสดงเมื่อเริ่มโปรโมชัน",
  "main.mart.product.landing.btn.addProduct": "เพิ่มรายการขาย",
  "main.mart.product.add.breadcrumb": "เพิ่มรายการขาย",
  "main.mart.product.add.header": "เพิ่มรายการขาย",
  "main.mart.product.add.form.tag.title": "เลือกประเภท",
  "main.mart.product.add.form.category.title": "หมวดหมู่",
  "main.mart.product.add.form.tag.placeholder": "เลือกประเภท",
  "main.mart.product.add.form.tag.isDeleted.placeholder": "เลือกประเภทอีกครั้ง",
  "main.mart.product.add.form.category.placeholder": "เลือกหมวดหมู่",
  "main.mart.product.add.form.category.addCategory": "เพิ่มหมวดหมู่",
  "main.mart.product.add.form.product.title": "ชื่อรายการ",
  "main.mart.product.add.form.product.placeholder": "ใส่ชื่อรายการ (ไม่เกิน 50 ตัวอักษร)",
  "main.mart.product.add.form.product.tips": "คำแนะนำการตั้งชื่อ\n      • ใช้ภาษาไทย ภาษาอังกฤษ หรือ ตัวเลขเท่านั้น\n      • สะกดคำให้ถูกต้อง\n      • ไม่ใช้สัญลักษณ์พิเศษหรืออิโมจิต่างๆ\n      • ไม่ใช้คำโปรยหรือคำโฆษณา\n      • ใช้ชื่อที่กระชับ ชัดเจน เข้าใจง่าย",
  "main.mart.product.add.form.description.title": "คำอธิบาย",
  "main.mart.product.add.form.description.placeholder": "ใส่คำอธิบายรายการหรือรายละเอียดเพิ่มเติม (ไม่เกิน 150 ตัวอักษร)",
  "main.mart.product.add.form.product.titleEN": "ชื่อรายการภาษาอังกฤษ",
  "main.mart.product.add.form.product.placeholderEN": "ใส่ชื่อรายการภาษาอังกฤษ (ไม่เกิน 50 ตัวอักษร)",
  "main.mart.product.add.form.description.titleEN": "คำอธิบายภาษาอังกฤษ",
  "main.mart.product.add.form.description.placeholderEN": "ใส่คำอธิบายรายการหรือรายละเอียดเพิ่มเติมภาษาอังกฤษ (ไม่เกิน 150 ตัวอักษร)",
  "main.mart.product.add.form.description.remarkEN": "หากไม่ระบุข้อมูลภาษาอังกฤษ ลูกค้าที่ใช้งานแอปเป็นภาษาอื่น\nจะเห็นชื่อและคำอธิบายรายการที่คุณระบุด้านบนแทน",
  "main.mart.product.add.form.SKU.title": "SKU",
  "main.mart.product.add.form.SKU.placeholder": "ใส่ SKU/รหัสอ้างอิงรายการ (ไม่เกิน 100 ตัวอักษร)",
  "main.mart.product.add.form.originalPrice.title": "ราคาเต็ม (บาท)",
  "main.mart.product.add.form.priceDiscount.title": "ราคาลด (บาท)",
  "main.mart.product.add.form.price.placeholder": "ใส่ราคา",
  "main.mart.product.add.form.startDateTime.title": "วัน/เวลาเริ่มต้น",
  "main.mart.product.add.form.endDateTime.title": "วัน/เวลาสิ้นสุด",
  "main.mart.product.add.form.price.tips": "ใส่ราคาที่รวมภาษีและค่าบริการแล้ว",
  "main.mart.product.add.form.price.validate": "กรุณาใส่ตัวเลขที่มีค่าทศนิยมไม่เกิน 2 ตำแหน่ง",
  "main.mart.product.add.form.detail.title": "ลักษณะสินค้า",
  "main.mart.product.add.form.detail.placeholder": "เช่น จำนวน น้ำหนัก หรือขนาดสินค้า",
  "main.mart.product.add.form.detail.error": "กรุณาเพิ่มลักษณะสินค้า",
  "main.mart.product.add.form.detail.btn.add": "เพิ่มลักษณะสินค้า",
  "main.mart.product.add.form.detail.btn.edit": "แก้ไขลักษณะสินค้า",
  "main.mart.product.add.form.amountPerOrder.title": "จำนวนที่ลูกค้าสั่งได้ในหนึ่งคำสั่งซื้อ",
  "main.mart.product.add.form.amountPerOrder.placeholder": "กรุณาเพิ่มลักษณะสินค้า",
  "main.mart.product.add.form.amountPerOrder.remark": "เพื่อการจัดส่งที่สะดวกและปลอดภัย\nจำนวนที่สั่งได้จะขึ้นอยู่กับน้ำหนักหรือขนาดบรรจุภัณฑ์ที่ระบุ",
  "main.mart.product.add.form.detail.modal.title": "ลักษณะสินค้า",
  "main.mart.product.add.form.detail.modal.piecesPerPack": "จำนวนชิ้นต่อแพ็ก",
  "main.mart.product.add.form.detail.modal.piecesPerPack.option1": "1 ชิ้นต่อแพ็ก",
  "main.mart.product.add.form.detail.modal.piecesPerPack.option2": "มากกว่า 1 ชิ้นต่อแพ็ก",
  "main.mart.product.add.form.detail.modal.piecesPerPack.option2.placeholder": "ระบุจำนวนชิ้นในหนึ่งแพ็ก",
  "main.mart.product.add.form.detail.modal.piecesPerPack.option2.required": "กรุณาระบุจำนวนชิ้นในหนึ่งแพ็ก",
  "main.mart.product.add.form.detail.modal.weightSizeLimit": "น้ำหนัก/ปริมาตรสินค้า",
  "main.mart.product.add.form.detail.modal.weightSizeLimit.option1": "ระบุน้ำหนัก/ปริมาตรของสินค้า 1 ชิ้น",
  "main.mart.product.add.form.detail.modal.weightSizeLimit.option1.required": "กรุณาระบุน้ำหนักหรือปริมาตรของสินค้า",
  "main.mart.product.add.form.detail.modal.sizeLimit.option2": "ไม่ระบุ - กรุณาเลือกขนาดแพ็ก",
  "main.mart.product.add.form.detail.modal.weightSizeLimit.sizeLimit.placeholder": "ใส่น้ำหนัก/ปริมาตร",
  "main.mart.product.add.form.picture.title": "รูป",
  "main.mart.product.add.form.picture.remark": "ไฟล์ .jpg หรือ .png ขนาดไม่เกิน 3 MB",
  "main.mart.product.add.form.picture.browse": "เลือกรูป",
  "main.mart.product.add.form.status.title": "สถานะรายการ",
  "main.mart.product.add.form.status.true": "แสดงรายการนี้บนหน้าจอแอปของทุกสาขา",
  "main.mart.product.add.form.status.false": "ไม่แสดงรายการนี้บนหน้าจอแอปทุกสาขา",
  "main.mart.product.add.form.action.submit": "เพิ่ม",
  "main.mart.product.add.form.action.cancel": "ยกเลิก",
  "main.mart.product.add.form.cannabis.remark": "*ห้ามจำหน่ายสินค้าที่มีส่วนผสมของ กัญชา, กระท่อม\nและสารเสพติดทุกประเภทโดยเด็ดขาด",
  "main.mart.product.add.form.error.notFoundProduct.title": "ไม่พบหมวดหมู่ที่คุณเลือก",
  "main.mart.product.add.form.error.notFoundProduct.content": "กรุณาเลือกหมวดหมู่อื่น หรือเพิ่มหมวดหมู่นี้ในร้านค้าของคุณก่อนเพิ่มรายการขาย",
  "main.mart.product.edit.breadcrumb": "แก้ไขรายการขาย",
  "main.mart.product.edit.header": "แก้ไขรายการขาย",
  "main.mart.product.edit.form.action.save": "บันทึก",
  "main.mart.product.delete.modal.deleteConfirmation.title": "ยืนยันการลบรายการ",
  "main.mart.product.delete.modal.deleteConfirmation.content": "คุณกำลังจะลบรายการนี้\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.mart.product.delete.alert.success": "ลบรายการขายสำเร็จแล้ว",
  "main.mart.product.delete.alert.failure": "ลบรายการขายไม่สำเร็จ กรุณาลองอีกครั้ง",
  "main.mart.product.tag.isDeleted": "กรุณาเลือกประเภทใหม่อีกครั้ง",
  "main.mart.product.addEdit.qc.desc": "หากมีการเพิ่มหรือแก้ไขรูป ชื่อ ราคา ระบบจะอนุมัติภายใน 3 วันทำการ หากไม่ได้รับผลการอนุมัติ กรุณาติดต่อ LINE OA: @robinhoodshop",
  "main.mart.product.qc.reject.reasons.header1": "รายการของคุณไม่ผ่านอนุมัติ เนื่องจาก",
  "main.mart.product.qc.reject.header1": "รายการของคุณไม่ผ่านอนุมัติ",
  "main.mart.product.qc.reject.header2": "กรุณาแก้ไขข้อมูล แล้วรอตรวจสอบภายใน 3 วันทำการ หรือติดต่อ LINE OA: @robinhoodshop",
  "main.mart.product.form.error.productPrice": "กรุณาใส่ราคาลดต่ำกว่าราคาเต็ม",
  // martTransfer
  "main.mart.category.transfer.breadcrumb": "ย้ายรายการทั้งหมด",
  "main.mart.category.transfer.header": "ย้ายรายการทั้งหมด",
  "main.mart.category.transfer.field.category.current.label": "หมวดหมู่ปัจจุบัน",
  "main.mart.category.transfer.field.category.new.label": "ย้ายรายการทั้งหมดไปยัง",
  "main.mart.category.transfer.field.category.new.placeholder": "เลือกหมวดหมู่",
  "main.mart.category.transfer.btn.confirm": "บันทึก",
  "main.mart.category.transfer.btn.cancel": "ยกเลิก",
  "main.mart.category.transfer.error.notfound.title": "ไม่สามารถดำเนินการต่อได้",
  "main.mart.category.transfer.error.notfound.desc": "คุณย้ายรายการทั้งหมดออกไปแล้ว",
  // Device management
  "main.deviceManagement.menu.text": "จัดการอุปกรณ์ที่ใช้งาน",
  "main.deviceManagement.header.text": "จัดการอุปกรณ์ที่ใช้งาน",
  "main.deviceManagement.breadcrumb.text": "จัดการอุปกรณ์ที่ใช้งาน",
  "main.deviceManagement.table.device": "อุปกรณ์",
  "main.deviceManagement.table.dateTimeLogin": "วันที่เข้าสู่ระบบ",
  "main.deviceManagement.subtitle.text": "หนึ่งอีเมลสามารถเข้าใช้งานพร้อมกันได้สูงสุด {maxDeviceLogin} เครื่อง",
  "main.deviceManagement.notfound.text": "ไม่พบอุปกรณ์ที่ใช้งาน",
  "main.deviceManagement.logout.text": "ออกจากระบบ",
  "main.deviceManagement.logout.modal.title": "ยืนยันการออกจากระบบบน",
  "main.deviceManagement.logout.modal.value": "{deviceDisplay}",
  "main.deviceManagement.logout.modal.content": "คุณกำลังลงชื่อออกจากอุปกรณ์เครื่องนี้\nคุณต้องการดำเนินการต่อหรือไม่",
  "main.deviceManagement.alert.success": "ออกจากระบบบน {deviceDisplay} สำเร็จแล้ว",
  // Modifier Item
  "main.menu.modifieritem.title": "รายการตัวเลือกเพิ่มเติม",
  "main.menu.modifieritem.subtitle": "จัดการรายการตัวเลือกเพิ่มเติม",
  "main.menu.modifieritem.total": "รายการทั้งหมด",
  "main.menu.modifieritem.selected.count": "เลือก {count} รายการ",
  "main.menu.modifieritem.delete.button": "ลบ",
  "main.menu.modifieritem.add.button": "เพิ่มตัวเลือก",
  "main.menu.modifieritem.column.name": "ชื่อตัวเลือก",
  "main.menu.modifieritem.column.nameEN": "ชื่อตัวเลือก (EN)",
  "main.menu.modifieritem.column.price": "ราคา (บาท)",
  "main.menu.modifieritem.column.sku_id": "รหัสอ้างอิง",
  "main.menu.modifieritem.column.status": "สถานะ",
  "main.menu.modifieritem.column.status.online": "ออนไลน์",
  "main.menu.modifieritem.column.status.offline": "ออฟไลน์",
  "main.menu.modifieritem.delete.confirm.title": "ยืนยันการลบ",
  "main.menu.modifieritem.delete.confirm.content": "คุณต้องการลบตัวเลือกเพิ่มเติมที่เลือกหรือไม่",
  "main.menu.modifieritem.create.modal.title": "เพิ่มตัวเลือกเพิ่มเติม",
  "main.menu.modifieritem.edit.modal.title": "แก้ไขตัวเลือกเพิ่มเติม",
  "main.menu.modifieritem.form.field.name": "ชื่อตัวเลือก",
  "main.menu.modifieritem.form.field.nameEN": "ชื่อตัวเลือก (EN)",
  "main.menu.modifieritem.form.field.price": "ราคา",
  "main.menu.modifieritem.form.field.sku": "รหัสอ้างอิง",
  "main.menu.modifieritem.form.field.required": "กรุณากรอกข้อมูล",
  "main.menu.modifieritem.form.field.nameENInvalid": "รูปแบบชื่อ EN ไม่ถูกต้อง",
  "main.menu.modifieritem.form.field.priceInvalid": "รูปแบบราคาไม่ถูกต้อง",
  "main.menu.modifiergroup.title": "กลุ่มตัวเลือก",
  "main.menu.modifiergroup.subtitle": "จัดการกลุ่มตัวเลือกของเมนู เช่น ตัวเลือกเผ็ดน้อย เผ็ดกลาง หรือเผ็ดมาก",
  "main.menu.modifiergroup.total.title": "กลุ่มตัวเลือกทั้งหมด",
  "main.menu.modifiergroup.add.button": "สร้างกลุ่มตัวเลือก",
  "main.menu.modifiergroup.search.placeholder": "ค้นหากลุ่มตัวเลือก",
  "main.menu.modifiergroup.column.name": "ชื่อกลุ่มตัวเลือก",
  "main.menu.modifiergroup.column.nameEN": "ชื่อกลุ่มตัวเลือกภาษาอังกฤษ",
  "main.menu.modifiergroup.column.total": "ตัวเลือกทั้งหมด",
  "main.menu.modifiergroup.column.condition": "เงื่อนไขการเลือก",
  "main.menu.modifiergroup.type.optional": "ไม่จำเป็นต้องเลือก",
  "main.menu.modifiergroup.type.select_one": "ต้องเลือก 1 ตัวเลือก",
  "main.menu.modifiergroup.type.multiple": "ต้องเลือกอย่างน้อย 1 ตัวเลือกขึ้นไป",
  "main.menu.modifiergroup.detail.sort": "เรียงลำดับตัวเลือก",
  "main.menu.modifiergroup.sort.modal.title": "เรียงลำดับกลุ่มตัวเลือก",
  "main.menu.modifiergroup.detail.title": "รายละเอียดกลุ่มตัวเลือก",
  "main.menu.modifiergroup.detail.name": "ชื่อกลุ่มตัวเลือก",
  "main.menu.modifiergroup.detail.nameEN": "ชื่อกลุ่มตัวเลือก (EN)",
  "main.menu.modifiergroup.detail.condition": "เงื่อนไขการเลือก",
  "main.menu.modifiergroup.detail.max": "จำนวนสูงสุด",
  "main.menu.modifiergroup.detail.items": "ตัวเลือกในกลุ่ม",
  "main.menu.modifiergroup.detail.delete.title": "ยืนยันการลบกลุ่มตัวเลือก",
  "main.menu.modifiergroup.detail.delete.confirm": "ลบ",
  "main.menu.modifiergroup.detail.delete.cancel": "ยกเลิก",
  "main.menu.modifiergroup.detail.delete.content": "ต้องการลบกลุ่มตัวเลือกนี้หรือไม่",
  "main.menu.modifiergroup.form.add.title": "สร้างกลุ่มตัวเลือก",
  "main.menu.modifiergroup.form.edit.title": "แก้ไขกลุ่มตัวเลือก",
  "main.menu.modifiergroup.form.field.name": "ชื่อกลุ่มตัวเลือก",
  "main.menu.modifiergroup.form.field.nameEN": "ชื่อกลุ่มตัวเลือก (EN)",
  "main.menu.modifiergroup.form.field.type": "เงื่อนไขการเลือก",
  "main.menu.modifiergroup.form.field.max": "จำนวนสูงสุด",
  "main.menu.modifiergroup.form.field.items": "ตัวเลือก",
  "main.menu.modifiergroup.form.field.required": "จำเป็นต้องกรอก",
  "main.menu.modifiergroup.form.field.max50": "ไม่เกิน 50 ตัวอักษร",
  "main.menu.modifiergroup.form.field.maxInvalid": "ต้องเป็นตัวเลข 1 ถึง {max}",
  "main.menu.modifiergroup.form.field.nameInvalid": "กรุณากรอกเป็นภาษาไทยหรืออังกฤษเท่านั้น",
  "main.menu.modifiergroup.form.field.nameENInvalid": "ต้องเป็นภาษาอังกฤษเท่านั้น",
  "main.menu.modifiergroup.form.button.addItems": "เพิ่มตัวเลือก",
  "main.menu.modifiergroup.form.modal.items.title": "เลือกตัวเลือก",
  "main.filter.clear": "ล้าง",
  "main.filter.apply": "ยืนยัน",
  "main.shared.multiselect.search-placeholder": "ค้นหา...",
  "main.shared.multiselect.no-results": "ไม่พบผลลัพธ์ที่ตรงกับคำค้นหา",
  "main.shared.multiselect.select-all": "เลือกทั้งหมด"
}
